import BaseComponent from './base_component';

export class ComponentRenderer {
    constructor(private _componentPrototype: any) {

    }


    private _hostElement: Element = null;
    private _componentInstance: BaseComponent = null;

    render(hostElement: Element, props?: any): void {


        this._disposeComponent();

        this._componentInstance = this._componentPrototype.create(props);
        hostElement.appendChild(this._componentInstance.getEl());
        this._componentInstance.start();
        this._componentInstance.onAppendedToDOM();
        this._hostElement = hostElement;
    }

    private _disposeComponent() {
        if(this._componentInstance) {
            this._componentInstance.shutDown();
            this._hostElement.removeChild(this._componentInstance.getEl());
            this._componentInstance = null;
        }
    }

    dispose() {
        this._disposeComponent();
        this._hostElement = null;
    }
}